import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { SiteLayout } from "@/components/SiteLayout";
import Home from "./pages/Home";
import Connect from "./pages/Connect";
import { CvRedirect } from "@/components/CvRedirect";

// Route-level code splitting — keeps the initial JS bundle small so the
// homepage paints fast (massive LCP win on mobile/slow networks).
const BlogIndex = lazy(() => import("./pages/BlogIndex"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Activity = lazy(() => import("./pages/Activity"));
const AdminLogin = lazy(() => import("./pages/admin/AdminLogin"));
const AdminEditor = lazy(() => import("./pages/admin/AdminEditor"));
const AuthSignIn = lazy(() => import("./pages/AuthSignIn"));
const OAuthConsent = lazy(() => import("./pages/OAuthConsent"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));

const queryClient = new QueryClient();


const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <SiteLayout>
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/activity" element={<Activity />} />
              <Route path="/cv" element={<CvRedirect />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/editor" element={<AdminEditor />} />
              <Route path="/mcp" element={<Connect />} />
              <Route path="/connect" element={<Connect />} />
              <Route path="/auth" element={<AuthSignIn />} />
              <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </SiteLayout>
      </BrowserRouter>
      <SpeedInsights />
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
